// Pure utility functions — no Firebase, no React, fully testable

export const pctClr = (p: number): string =>
  p >= 80 ? '#22c55e' : p >= 60 ? 'var(--accent)' : '#f97316';

export function srCardId(front: string): string {
  let h = 0;
  for (let i = 0; i < front.length; i++) h = Math.imul(31, h) + front.charCodeAt(i) | 0;
  return Math.abs(h).toString(36);
}

export type SRCard = { ef: number; interval: number; reps: number; due: number };

export function sm2Update(card: SRCard | undefined, rating: 0 | 3 | 5): SRCard {
  const prevEF = card?.ef ?? 2.5;
  const ef = Math.max(1.3, prevEF + 0.1 - (5 - rating) * (0.08 + (5 - rating) * 0.02));
  const reps = rating < 3 ? 0 : (card?.reps ?? 0) + 1;
  const interval =
    rating < 3 ? 1 :
    reps === 1 ? 1 :
    reps === 2 ? 6 :
    Math.round((card?.interval ?? 1) * ef);
  return { ef, interval, reps, due: Date.now() + interval * 86400000 };
}

export function shuffle<T>(arr: T[]): T[] {
  const r = [...arr];
  for (let i = r.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [r[i], r[j]] = [r[j], r[i]];
  }
  return r;
}

export function calcStreak(records: { date: string }[]): number {
  const allDays = Array.from(new Set(records.map(r => r.date.slice(0, 10))))
    .sort((a, b) => b.localeCompare(a));
  if (!allDays.length) return 0;
  const today = new Date().toISOString().slice(0, 10);
  const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
  if (allDays[0] !== today && allDays[0] !== yesterday) return 0;
  let streak = 0;
  for (let i = 0; i < allDays.length; i++) {
    const expected = new Date(new Date(allDays[0]).getTime() - i * 86400000).toISOString().slice(0, 10);
    if (allDays[i] === expected) streak++;
    else break;
  }
  return streak;
}

export function calcTrendDelta(records: { date: string; pct: number }[]): number | null {
  const sorted = [...records].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  const last5 = sorted.slice(-5);
  const prev5 = sorted.slice(-10, -5);
  if (last5.length < 3 || prev5.length < 3) return null;
  const avg = (arr: { pct: number }[]) => arr.reduce((s, r) => s + r.pct, 0) / arr.length;
  return Math.round(avg(last5) - avg(prev5));
}
